<template>
  <v-snackbar top v-model="computedSnackbarVisibility" style="z-index: 999;">
    Successfully saved to database
    <v-btn @click.stop="methodUiDialogsSnackbarSaved(false)" flat color="pink"
      >Close</v-btn
    >
  </v-snackbar>
</template>
<script>
export default {
  computed: {
    computedSnackbarVisibility() {
      return this.$store.state.ui.dialogs.snackbar_saved;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodUiDialogsSnackbarSaved(state) {
      this.$store.commit("mutationDialogSnackbarSaved", state);
    }
  }
};
</script>
